// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__JhHD9","title":"Info_title__19_9e","selects":"Info_selects__2rucM","requiredAsterisk":"Info_requiredAsterisk__JiyRJ"};